import { createClient } from '@sanity/client';

export const sanityProjectId =
  import.meta.env.VITE_SANITY_PROJECT_ID ?? '1l34n528';
export const sanityDataset =
  import.meta.env.VITE_SANITY_DATASET ?? 'landlord-production';
const sanityApiVersion = '2026-10-01';

/** Server-only: the read token lets non-production environments preview drafts. */
export function createSanityClient() {
  const readToken = process.env.SANITY_READ_TOKEN;
  if (readToken && import.meta.env.VITE_SANITY_PERSPECTIVE === 'drafts') {
    return createClient({
      projectId: sanityProjectId,
      dataset: sanityDataset,
      apiVersion: sanityApiVersion,
      perspective: 'drafts',
      token: readToken,
    });
  }
  return createClient({
    projectId: sanityProjectId,
    dataset: sanityDataset,
    apiVersion: sanityApiVersion,
    perspective: 'published',
    useCdn: true,
  });
}
